<template>
  <AwlTable :heading="tableHeadings" :rows="tableRows" striped>
    <template #column-key-totalCost="{ value }">
      {{ value | money }}
    </template>
    <template #column-key-ricavo="{ value }">
      {{ value | money }}
    </template>
    <template #column-key-vat="{ value }">
      {{ value }}%
    </template>

    <template v-if="editEnabled" #actions-content="{ row }">
      <ActionEdit class="mr-0 mr-md-2" :to="{ name: 'operative-company.projects.library.templates.edit', params: { projectLibraryTemplateId: row.id } }" />
      <ActionDelete @click="remove(row.id)" />
    </template>
  </AwlTable>
</template>

<script>

import formatMoneyFilter from '@/filters/formatMoney';

export default {
  name: 'templates-list-table',
  components: {
    AwlTable: () => import('@/libs/Table/components/AwlTable'),
    ActionDelete: () => import('@/views/components/Actions/ActionDelete'),
    ActionEdit: () => import('@/views/components/Actions/ActionEdit'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  props: {
    templates: {
      type: Array,
      default: () => [],
    },
    editEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tableHeadings () {
      return [
        { key: 'name', label: 'Nome' },
        { key: 'totalCost', label: 'Costo totale' },
        { key: 'ricavo', label: 'Ricavo' },
        { key: 'vat', label: 'Iva' },
      ];
    },
    tableRows () {
      return (this.templates || []).map(r => {
        return r;
      });
    },
  },
  methods: {
    remove (id) {
      if (!this.editEnabled) {
        return;
      }

      this.$emit('delete', id);
    },
  },
};

</script>
